import { requestGet } from '@/utils/request';
import type { Organization } from '@/components/PeopleRoleSelect/SelectRoleOrMemberModal/SelectRoleOrPerson/components/MemberTree/type';
import { TApi } from '@/types/interface';

export async function getMemberTree(): Promise<TApi<Organization>> {
  return requestGet(`/v2/camp/api/user/organization`, {});
}
